import { render, staticRenderFns } from "./addAirline.vue?vue&type=template&id=e895b2e2&scoped=true"
import script from "./addAirline.vue?vue&type=script&lang=js"
export * from "./addAirline.vue?vue&type=script&lang=js"
import style0 from "./addAirline.vue?vue&type=style&index=0&id=e895b2e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e895b2e2",
  null
  
)

export default component.exports